import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import "./PoolDecks.scss";
import "../../index.scss";

//Panels
import Modal from "../../../Modal/Modal";

//Images
import pooldecks1 from "../../../images/categories/pooldecks/PPI-pools-001.jpg";
import pooldecks2 from "../../../images/categories/pooldecks/PPI-pools-002.jpg";
import pooldecks3 from "../../../images/categories/pooldecks/PPI-pools-003.jpg";
import pooldecks4 from "../../../images/categories/pooldecks/PPI-pools-004.jpg";
import pooldecks5 from "../../../images/categories/pooldecks/PPI-pools-005.jpg";
import pooldecks6 from "../../../images/categories/pooldecks/PPI-pools-006.jpg";
import pooldecks7 from "../../../images/categories/pooldecks/PPI-pools-007.jpg";
import pooldecks8 from "../../../images/categories/pooldecks/PPI-pools-008.jpg";
import pooldecks9 from "../../../images/categories/pooldecks/PPI-pools-009.jpg";
import pooldecks10 from "../../../images/categories/pooldecks/PPI-pools-010.jpg";
import pooldecks11 from "../../../images/categories/pooldecks/PPI-pools-011.jpg";
import pooldecks12 from "../../../images/categories/pooldecks/PPI-pools-012.jpg";
import pooldecks13 from "../../../images/categories/pooldecks/PPI-pools-013.jpg";
import pooldecks14 from "../../../images/categories/pooldecks/PPI-pools-014.jpg";
import pooldecks15 from "../../../images/categories/pooldecks/PPI-pools-015.jpg";
import pooldecks16 from "../../../images/categories/pooldecks/PPI-pools-016.jpg";
import pooldecks17 from "../../../images/categories/pooldecks/PPI-pools-017.jpg";
import pooldecks18 from "../../../images/categories/pooldecks/PPI-pools-018.jpg";
import pooldecks19 from "../../../images/categories/pooldecks/PPI-pools-019.jpg";
import pooldecks20 from "../../../images/categories/pooldecks/PPI-pools-020.jpg";
import pooldecks21 from "../../../images/categories/pooldecks/PPI-pools-021.jpg";
import pooldecks22 from "../../../images/categories/pooldecks/PPI-pools-022.jpg";
import pooldecks23 from "../../../images/categories/pooldecks/PPI-pools-023.jpg";
import pooldecks24 from "../../../images/categories/pooldecks/PPI-pools-024.jpg";
import pooldecks25 from "../../../images/categories/pooldecks/PPI-pools-025.jpg";
import pooldecks26 from "../../../images/categories/pooldecks/PPI-pools-026.jpg";
import pooldecks27 from "../../../images/categories/pooldecks/PPI-pools-027.jpg";
import pooldecks28 from "../../../images/categories/pooldecks/PPI-pools-028.jpg";
import pooldecks29 from "../../../images/categories/pooldecks/PPI-pools-029.jpg";
import pooldecks30 from "../../../images/categories/pooldecks/PPI-pools-030.jpg";
import pooldecks31 from "../../../images/categories/pooldecks/PPI-pools-031.jpg";
import pooldecks32 from "../../../images/categories/pooldecks/PPI-pools-032.jpg";
import pooldecks33 from "../../../images/categories/pooldecks/PPI-pools-033.jpg";
import pooldecks34 from "../../../images/categories/pooldecks/PPI-pools-034.jpg";
import pooldecks35 from "../../../images/categories/pooldecks/PPI-pools-035.jpg";
//Utils
import { mapGallery } from "../../../../../Utils/Utils";

//SEO
import SEO from "../../../../../SEO/index";
import StructuredData from "../../../../../SEO/structuredData";

const PoolDecks = () => {
  const [showModal, setShowModal] = useState(false);
  const [current, setCurrent] = useState(0);

  const images = [
    {
      image: pooldecks1,
      description:
        "Charcoal paving stone pool deck with poured concrete pool lining.",
      aria: "Charcoal paving stone pool deck with poured concrete pool lining",
    },
    {
      image: pooldecks2,
      description:
        "Hollywood Hills backyard overlook with sand colored paving stone patio, custom infinity pool and outdoor kitchen gazebo.",
      aria: "Hollywood Hills backyard with sand colored paving stone patio, pool & outdoor kitchen gazebo",
    },
    {
      image: pooldecks3,
      description:
        "2014 Pasadena Showcase house of design pool and patio. We installed this Pasadena Pool deck with different styles of paving stones to create unique shapes and patterns. This gave the finished product a refined and elegant look.",
      aria: "Pool and patio with different styles of paving stone pool decks",
    },
    {
      image: pooldecks4,
      description:
        "Concrete slab pool deck with earth-tone tiled pool in Los Angeles, CA.",
      aria: "Concrete slab pool deck with earth-tone tiled pool in Los Angeles, CA",
    },
    {
      image: pooldecks5,
      description:
        "Large concrete slab pool deck with matching pool lining and custom steps with built-in lighting.",
      aria: "Concrete slab pool deck with matching pool lining and custom steps with built-in lighting",
    },
    {
      image: pooldecks6,
      description:
        "Kidney shaped pool with paving stone pool deck and retaining wall. Tiling around the pool and spa compliment the paver color to create a cohesive look.",
      aria: "Kidney shaped pool with paving stone pool deck and retaining wall",
    },
    {
      image: pooldecks7,
      description:
        "Mediteranean pool with custom half-moon shaped seating bench and large flagstone pool deck in Los Angeles, CA.",
      aria: "Mediterranean pool with half-moon shaped seating bench & large flagstone pool deck in Los Angeles, CA",
    },
    {
      image: pooldecks8,
      description:
        "Spa-inspired pool with grass in between paving stone pool deck clusters. A skinny paving stone walkway leads to two paving stone island outcroppings that are perfect landing places for pool furniture.",
      aria: "Pool with grass in between paving stone pool deck clusters and furniture",
    },
    {
      image: pooldecks9,
      description:
        "Charcoal paving stone pool deck with accent lighting, grass accents and dining area.",
      aria: "Charcoal paving stone pool deck with accent lighting, grass accents and dining area",
    },
    {
      image: pooldecks10,
      description:
        "Freeform pool with paving stone pool deck, drought tolerant planting landscape lighting in Santa Clarita, CA.",
      aria: "Freeform pool with paving stone pool deck, drought tolerant plants and lighting in Santa Clarita, CA",
    },
    {
      image: pooldecks11,
      description:
        "Porcelain paver pool deck with terracotta colored stone around the pool lip. Dark blue tiles were also placed along the pool’s retaining wall to add a focal point to the space.",
      aria: "Porcelain paver pool deck with terracotta colored stone around the pool lip",
    },
    {
      image: pooldecks12,
      description:
        "Expansive hardscape backyard including a pool, swim-up bar, fire features, planter beds and multiple styles of hardscaping. Some materials include concrete slabs, paving stones, flagstone, stucco and natural stone accents.",
      aria: "Backyard including a pool, swim-up bar, fire features, planter beds & multiple styles of hardscaping",
    },
    {
      image: pooldecks13,
      description:
        "Hollywood Hills infinity pool and pool deck made from paving stones with an accent fire pit constructed from tile.",
      aria: "Hollywood Hills infinity pool & pool deck made from paving stones with an accent fire pit",
    },
    {
      image: pooldecks14,
      description:
        "Kidney shaped pool with paving stone pool deck surrounding it. Ample space for pool furniture as well as a dining area and outdoor kitchen unit.",
      aria: "Kidney shaped pool with paving stone pool deck, dining area, and furniture surrounding it",
    },
    {
      image: pooldecks15,
      description:
        "Infinity pool in Pacific Palisades, CA with porcelain paving stone pool deck and spa. This beautiful hilltop pool and spa is complete with pool lighting, non-slip porcelain paving stones and a custom pergola.",
      aria: "Infinity pool in Pacific Palisades, CA with porcelain paving stone pool deck and spa",
    },
    {
      image: pooldecks16,
      description:
        "Modern pool with porcelain pavers and an in-ground water feature. This salt water pool is equipped with color changing lighting as well as remote controlled pool fountains.",
      aria: "Modern pool with porcelain pavers and an in-ground water feature",
    },
    {
      image: pooldecks17,
      description:
        "Small backyard pool in Los Feliz, CA with a concrete slab pool deck. Multiple Drainage outlets were also installed throughout the deck to prevent pooling water.",
      aria: "Small backyard pool in Los Feliz, CA with a concrete slab pool deck",
    },
    {
      image: pooldecks18,
      description:
        "Complete pool and hardscape remodel for the 2014 Pasadena Showcase House of Design home in Pasadena, CA. This space features multiple styles and variations of paving stones to create elegant patterns in the hardscape.",
      aria: "Complete pool and hardscape surrounded by trees and plants in Pasadena, CA",
    },
    {
      image: pooldecks19,
      description:
        "Pasadena Showcase House of Design pool remodel. Included in this design is outdoor lighting, pool lighting and a custom pool water feature.",
      aria: "Pool surrounded by outdoor lighting, patio, home, and plants",
    },
    {
      image: pooldecks20,
      description:
        "Pasadena, CA pool at night featuring color-changing pool lights coupled with a paving stone pool deck laid out in a herringbone pattern.",
      aria: "Pasadena, CA pool at night featuring color-changing pool lights with a paving stone pool deck",
    },
    {
      image: pooldecks21,
      description:
        "Freeform pool with sand colored paving stones, retaining walls, garden beds and a sunken fire pit attached to the pool.",
      aria: "Freeform pool with sand colored paving stones, retaining walls, garden beds and a sunken fire pit",
    },
    {
      image: pooldecks22,
      description:
        "Paving stone pool deck leading into a custom gazebo that overhangs a multi-tiered waterfall feature.",
      aria: "Paving stone pool deck leading into a custom gazebo that overhangs a multi-tiered waterfall feature",
    },
    {
      image: pooldecks23,
      description:
        "Traditional style pool with gray paving stone pool deck. This design mimics the regalness of a full olympic style pool.",
      aria: "Traditional style pool with gray paving stone pool deck",
    },
    {
      image: pooldecks24,
      description:
        "Paving stone pool deck in Los Angeles, CA with complimentary spa tiles.",
      aria: "Paving stone pool deck in Los Angeles, CA with complimentary spa tiles",
    },
    {
      image: pooldecks25,
      description:
        "Earth-tone paving stone pool deck with juxtaposing deep blue tiling on the spa. The neutral tones of the paving stones provide the perfect backdrop for the pool to shine.",
      aria: "Earth-tone paving stone pool deck with juxtaposing deep blue tiling on the spa",
    },
    {
      image: pooldecks26,
      description:
        "Modern pool design with geometric features and a structured hardscape design. This space was constructed with paving stones, and contains built-in step lighting.",
      aria: "Modern pool design with geometric features and a structured hardscape design",
    },
    {
      image: pooldecks27,
      description:
        "Modern pool with hardscape steps, raised pool deck and outdoor lighting in Encino, CA.",
      aria: "Modern pool with hardscape steps, raised pool deck and outdoor lighting in Encino, CA",
    },
    {
      image: pooldecks28,
      description:
        "Mediterranean style backyard with multi-colored paving stones in Los Angeles, CA.",
      aria: "Mediterranean style backyard with multi-colored paving stones in Los Angeles, CA",
    },
    {
      image: pooldecks29,
      description:
        "Mediteranean style design made with ornamental planters, a pool deck made from large paving stones, and a raised setting area with custom steps.",
      aria: "Mediterranean style design made with ornamental planters, pool deck, & a raised setting area",
    },
    {
      image: pooldecks30,
      description:
        "Poolside gazebo and paving stone pool deck with brick accents in Encino, CA.",
      aria: "Poolside gazebo and paving stone pool deck with brick accents in Encino, CA",
    },
    {
      image: pooldecks31,
      description:
        "Small backyard pool and paving stone deck with gas fire pit and a custom seating wall.",
      aria: "Small backyard pool and paving stone deck with gas fire pit and a custom seating wall",
    },
    {
      image: pooldecks32,
      description:
        "Modern pool deck and patio in Eagle Rock, CA. This multi-level backyard includes two seating areas, a pool and expansive tile pool deck.",
      aria: "Modern pool deck and patio in Eagle Rock, CA with two seating areas and stairs",
    },
    {
      image: pooldecks33,
      description:
        "This backyard used to be a muddy slope until we created a multi-tiered paving stone pool deck and steps with built-in lighting to add more usability to the space.",
      aria: "Multi-tiered paving stone pool deck, pool & steps with built-in lighting",
    },
    {
      image: pooldecks34,
      description:
        "Ultra modern hillside backyard with natural stones segmenting the pool from the tile deck. Design also includes concrete slabs under the raised patio to add covered poolside seating.",
      aria: "Hillside backyard with natural stones segmenting the pool from the tile deck",
    },
    {
      image: pooldecks35,
      description:
        "This backyard design is a combination of traditional and contemporary and showcases gray paving stone deck, modern lantern light fixtures, outdoor dining and seating areas as well as a salt water pool.",
      aria: "Backyard with gray paving stone deck, lantern lights, outdoor dining & seating areas & pool",
    },
  ];

  return (
    <>
      <SEO
        title="Pool Deck Ideas | Southern California | Pacific Pavingstone"
        description="View the beautiful pool deck projects we've completed in Southern California. Gain inspiration and ideas for your next project today!"
        profileURL={"https://www.pacificpavingstone.com/gallery/pool-decks"}
        type="website"
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org",
          "@type": "ImageGallery",
          name: "Completed Pool Deck Gallery",
          description:
            "View the beautiful pool deck projects we've completed in Southern California. Gain inspiration and ideas for your next project today!",
          image:
            "https://www.pacificpavingstone.com/static/media/PPI-pools-031.5544f903.jpg",
          URL: "https://www.pacificpavingstone.com/contact-us",
        }}
      />
      <div className="container-fluid no-side-padding gallery-wrapper">
        <div className="row justify-content-center">
          <div className="col-11">
            <div className="row gallery-images">
              {mapGallery(images, "pools", setShowModal, setCurrent)}
            </div>
          </div>
        </div>
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          items={images}
          current={current}
        />
      </div>
    </>
  );
};

export default PoolDecks;
